import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("LetterManagerPermissions")
export class LetterManagerPermissions {
    static readonly None = 0;
    static readonly Create = 1;
    static readonly Edit = 2;
}
